import React, { Component } from "react";
import avatar from "../../assets/images/logout.png";
import "./avatarImage.css";

import axios from "axios";
import $ from "jquery";

class AvatarImage extends Component {
    state = {
        className: "avatar-image",
        opened: false
    };

    openUserPanelHandler = () => {
        let className = this.state.className;
        let opened = this.state.opened;
        if (opened) {
            className = "avatar-image";
            opened = !opened;
        } else {
            className = "avatar-image open";
            opened = !opened;
        }
        this.setState({ className, opened });
    };

    closeApp = e => {
        e.preventDefault();
        // axios
        //     .get("http://psychologytest.tsu.ge/backend/studenti/tocken")
        //     .then(response => {
        //         let string = response.data.token;

        //         $.ajax({
        //             url: "",
        //             dataType: "json",
        //             type: "GET",
        //             success: response => {},
        //             error: (response = e => {
        //                 console.log(e);
        //             })
        //         });
        //     });
        window.open("http://psychologytest.tsu.ge/backend/logout", "_self");
        // window.location.href = "http://psychologytest.tsu.ge/backend/logout";
    };

    render() {
        let className = this.state.className;

        return (
            <div className={className} onClick={this.openUserPanelHandler}>
                <img src={avatar} alt="avatar-image" onClick={this.closeApp} />
                <div className="user-Details">
                    <span className="avatar-nav">გამოსვლა</span>
                </div>
            </div>
        );
    }
}

export default AvatarImage;
